
//uncomment below line to enable panels on local setup
//and run command kubectl port-forward --address 0.0.0.0 service/atmos-grafana 3001:3000

export const panelPublicUrl = process.env.PUBLIC_URL

// export const panelPublicUrl = "http://172.20.0.7:3001"
// export const panelPublicUrl = "http://172.20.0.6:3001"